import { FC, Reducer, useCallback, useEffect, useReducer, useState } from 'react';
import { Box } from '@mui/material';
import { StepperContentWrapper } from '../../../shared/lib/theme/styleConstants';
import { StepperStepsProps } from '../app/interfaceTypes';
import { BillingStepOne } from './BillingStepOne';
import { BillingStepTwo } from './BillingStepTwo';
import { PAuthAction, PAuthInitialState, PAuthReducer, PAuthState } from '../app/reducer/PAuthReducer';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';

export const BillingStep: FC<StepperStepsProps & { onBillingCardChange?: (val: boolean) => void; isChangePlan?: boolean }> = ({ handleNext, onBillingCardChange, isChangePlan }) => {
  const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

  const [stripe, setStripe] = useState<Stripe | null>(null);
  const [billingCard, setBillingCard] = useState<boolean>(false);
  const [state, dispatch] = useReducer<Reducer<PAuthState, PAuthAction>>(PAuthReducer, PAuthInitialState);

  const loadStripeConfig = useCallback(async () => {
    const response = await loadStripe(stripePublicKey);
    if (response) {
      setStripe(response);
    }
  }, [stripePublicKey]);

  useEffect(() => {
    stripePublicKey && loadStripeConfig();
  }, [loadStripeConfig, stripePublicKey]);

  useEffect(() => {
    onBillingCardChange?.(billingCard);
  }, [billingCard]);

  return (
    <Box sx={{ ...StepperContentWrapper, justifyContent: 'start' }}>
      <Elements stripe={stripe}>
        {billingCard ? (
          <BillingStepTwo setBillingCard={setBillingCard} handleNext={handleNext} dispatch={dispatch} state={state} isChangePlan={isChangePlan} />
        ) : (
          <BillingStepOne setBillingCard={setBillingCard} dispatch={dispatch} state={state} />
        )}
      </Elements>
    </Box>
  );
};
